import styles from '../css/DemoModeBanner.module.css'
import { MdOutlineInfo } from "react-icons/md";

export const DemoModeBanner = ({tab}) => {
  return (
    <div role="status" className={`${styles.banner} ${styles[tab]}`}>
        <div className = {styles.icon}>
            <MdOutlineInfo />
        </div>
        <div>
            <p className={styles.title}>Demo mode</p>
            <p className={styles.message}>
                User Details can't be changed on the demo account. Sign up for a real account to manage credentials.
            </p>
        </div>
    </div>
  )
}

export default DemoModeBanner